const appError = {
  instance(message, stop) {
    let error = new Error(message);
    error.stop = stop || false;
    return error;
  }
};

export default appError;
